const React = globalThis.React;

export function PriceSection(props) {
  const {
    detailsOpen,
    intPart,
    decPart,
    hasMyHomePromo,
    hasPromo,
    originalPrice,
    hasSavings,
    savingsPercent,
    savingsMonthly,
    savingsDaily,
    savingsYear,
    savingsTwoYears,
    isMyHome,
    isPrepaid,
    connectionFee,
    isComboDiscounted,
    totalCost,
    effectivePrice,
    termMonths,
    title,
    onEditRequest,
    id
  } = props;

  const isJahrespaket = isPrepaid && title && title.toLowerCase().includes('jahrespaket');
  const isConsumptionBased = isPrepaid && effectivePrice === 0;
  const priceLabel = isConsumptionBased ? '€ Grundgebühr' : isJahrespaket ? '€/Jahr' : isPrepaid ? '€/4 Wo.' : '€/Monat';
  const perDay = isJahrespaket ? (effectivePrice / 365) : (effectivePrice / 30);

  if (!detailsOpen) {
    return (
      <>
        <div className="flex items-baseline justify-center gap-1 font-heading text-sky-50">
          <span className="price-glow-main text-[2.35rem] font-extrabold leading-none">{intPart}</span>
          <span className="text-cyan-300 font-extrabold leading-none text-[1.5rem]">,{decPart}</span>
          <span className="text-[0.95rem] font-semibold leading-none pb-1">{priceLabel}</span>
        </div>
        {hasSavings && !isMyHome && (
          <div className="mt-2 flex flex-col items-center">
            <div className="statt-price-text text-[0.75rem] leading-none line-through">
              statt {originalPrice.toFixed(2).replace(".", ",")} €
            </div>
            <div className="mt-[6px] inline-flex items-center justify-center px-3 py-0.5 rounded-full border border-cyan-300/60 bg-cyan-500/15 text-[0.68rem] font-semibold text-cyan-100">
              {savingsPercent}% Ersparnis!
            </div>
          </div>
        )}
        {!isPrepaid && (
          <div className="mt-2 mb-20">
            {connectionFee > 0 ? (
              <div className="text-[0.65rem] font-semibold poppins-anschlusspreis connection-fee-neon">
                + Anschlusspreis: {connectionFee.toFixed(2).replace(".", ",")} €
              </div>
            ) : (
              <div className="text-[0.65rem] font-semibold poppins-anschlusspreis connection-fee-free-neon">
                Anschlusspreis frei
              </div>
            )}
          </div>
        )}
        {isPrepaid && (
          <div className="mt-2 mb-12">
            {isConsumptionBased && (
              <div className="text-[0.65rem] font-semibold text-cyan-200/80">Verbrauchsbasiert – keine Grundgebühr</div>
            )}
            {isJahrespaket && (
              <div className="text-[0.65rem] font-semibold text-cyan-200/80">Einmalzahlung für 365 Tage</div>
            )}
          </div>
        )}
        {isMyHome && hasPromo && (
          <div className="mt-[4px]">
            <div className="text-[0.7rem] font-semibold text-orange-400" style={{ textShadow: '0 0 10px rgba(251, 146, 60, 0.6), 0 0 20px rgba(251, 146, 60, 0.3)' }}>
              ab dem 13. Monat: {originalPrice.toFixed(2).replace(".", ",")} €
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      {hasMyHomePromo && hasPromo ? (
        <div className="flex flex-col items-center gap-1">
          <div className="flex items-baseline justify-center gap-1 font-heading text-sky-50">
            <span className="price-glow-main text-[2.35rem] font-extrabold leading-none">{intPart}</span>
            <span className="text-cyan-300 font-extrabold leading-none text-[1.5rem]">,{decPart}</span>
            <span className="text-[0.95rem] font-semibold leading-none pb-1">{priceLabel}</span>
          </div>
        </div>
      ) : (
        <div className="flex items-baseline justify-center gap-1 font-heading text-sky-50">
          <span className="price-glow-main text-[2.35rem] font-extrabold leading-none">{intPart}</span>
          <span className="text-cyan-300 font-extrabold leading-none text-[1.5rem]">,{decPart}</span>
          <span className="text-[0.95rem] font-semibold leading-none pb-1">{priceLabel}</span>
        </div>
      )}

      <div className="mt-3">
        {isMyHome && hasPromo ? (
          <div className="mt-2">
            <div className="text-[0.8rem] font-semibold text-cyan-300">
              ab dem 13. Monat: {originalPrice.toFixed(2).replace(".", ",")} €
            </div>
          </div>
        ) : hasSavings ? (
          <div className="flex flex-col items-center">
            <div className="statt-price-text text-[0.8rem] leading-none line-through">
              statt {originalPrice.toFixed(2).replace(".", ",")} €
            </div>
            <div className="mt-[6px] inline-flex items-center justify-center px-3 py-0.5 rounded-full border border-cyan-300/60 bg-cyan-500/15 text-[0.68rem] font-semibold text-cyan-100">
              {savingsPercent}% Ersparnis!
            </div>
          </div>
        ) : (
          isComboDiscounted ? (
            <div className="text-[0.72rem] font-semibold text-cyan-100">
              Bestandskundenpreis
            </div>
          ) : null
        )}
      </div>

      {!isPrepaid && (
        connectionFee > 0 ? (
          <div className="mt-2 text-[0.6rem] font-semibold">
            <span className="connection-fee-neon poppins-anschlusspreis font-bold">
              + Anschlusspreis: {connectionFee.toFixed(2).replace(".", ",")} €
            </span>
          </div>
        ) : (
          <div className="mt-2 text-[0.6rem] font-semibold">
            <span className="connection-fee-free-pink poppins-anschlusspreis">
              Anschlusspreis frei
            </span>
          </div>
        )
      )}

      <div className="bg-[#010b24] px-5 pb-4 pt-3 border-t border-sky-900/40 text-sky-100">
        <div className="space-y-3">
          <div className="flex items-center gap-2 pb-2 border-b border-sky-800/30">
            <svg className="w-4 h-4 text-cyan-400 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="10"/>
              <path d="M12 6v6l4 2"/>
            </svg>
            <span className="text-[0.7rem] uppercase tracking-wider text-sky-400/90 font-semibold">
              {isPrepaid
                ? (isJahrespaket ? 'Prepaid – 365 Tage Laufzeit' : 'Prepaid – keine Vertragsbindung')
                : `Vertragslaufzeit: ${termMonths} Monate`}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-3">
            {!isPrepaid && (
              <div className="bg-sky-950/40 rounded-lg p-2.5 border border-sky-800/30">
                <div className="text-[0.62rem] uppercase tracking-wide text-sky-400/70 mb-1">24 Monate</div>
                <div className="text-[0.82rem] font-bold text-sky-50">
                  {(effectivePrice * 24).toFixed(2).replace(".", ",")} €
                </div>
              </div>
            )}
            {!isPrepaid && (
              <div className="bg-sky-950/40 rounded-lg p-2.5 border border-sky-800/30">
                <div className="text-[0.62rem] uppercase tracking-wide text-sky-400/70 mb-1">12 Monate</div>
                <div className="text-[0.82rem] font-bold text-sky-50">
                  {(effectivePrice * 12).toFixed(2).replace(".", ",")} €
                </div>
              </div>
            )}
            {isJahrespaket ? (
              <div className="bg-sky-950/40 rounded-lg p-2.5 border border-sky-800/30 col-span-2">
                <div className="text-[0.62rem] uppercase tracking-wide text-sky-400/70 mb-1">Jahrespreis (einmalig)</div>
                <div className="text-[0.82rem] font-bold text-sky-50">
                  {effectivePrice.toFixed(2).replace(".", ",")} €
                </div>
              </div>
            ) : isConsumptionBased ? (
              <div className="bg-sky-950/40 rounded-lg p-2.5 border border-sky-800/30 col-span-2">
                <div className="text-[0.62rem] uppercase tracking-wide text-sky-400/70 mb-1">Grundgebühr</div>
                <div className="text-[0.82rem] font-bold text-sky-50">
                  0,00 € – verbrauchsbasiert
                </div>
              </div>
            ) : (
              <>
                <div className="bg-sky-950/40 rounded-lg p-2.5 border border-sky-800/30">
                  <div className="text-[0.62rem] uppercase tracking-wide text-sky-400/70 mb-1">{isPrepaid ? '4 Wochen' : '1 Monat'}</div>
                  <div className="text-[0.82rem] font-bold text-sky-50">
                    {effectivePrice.toFixed(2).replace(".", ",")} €
                  </div>
                </div>
                <div className="bg-sky-950/40 rounded-lg p-2.5 border border-sky-800/30">
                  <div className="text-[0.62rem] uppercase tracking-wide text-sky-400/70 mb-1">Pro Tag</div>
                  <div className="text-[0.82rem] font-bold text-sky-50">
                    {perDay.toFixed(2).replace(".", ",")} €
                  </div>
                </div>
              </>
            )}
            {isJahrespaket && (
              <div className="bg-sky-950/40 rounded-lg p-2.5 border border-sky-800/30 col-span-2">
                <div className="text-[0.62rem] uppercase tracking-wide text-sky-400/70 mb-1">Pro Tag</div>
                <div className="text-[0.82rem] font-bold text-sky-50">
                  {perDay.toFixed(2).replace(".", ",")} €
                </div>
              </div>
            )}
          </div>

          {hasSavings && (
            <div className="relative rounded-xl p-4 border-2 border-cyan-400/70 bg-gradient-to-br from-cyan-500/30 via-blue-500/25 to-slate-900/80 overflow-hidden shadow-[0_0_20px_rgba(34,211,238,0.45)]">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_25%_30%,rgba(34,211,238,0.4),transparent_70%)] pointer-events-none"></div>
              <div className="relative">
                <div className="flex items-center gap-2 mb-2">
                  <svg className="w-5 h-5 text-cyan-300 drop-shadow-[0_0_8px_rgba(34,211,238,0.9)]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  <div className="text-[0.75rem] uppercase tracking-wider text-cyan-200 font-bold">Ihre Ersparnis</div>
                  <div className="ml-auto px-2.5 py-0.5 rounded-full bg-cyan-400/40 border border-cyan-300/60">
                    <span className="text-[0.7rem] font-black text-cyan-50">{savingsPercent}%</span>
                  </div>
                </div>
                <div className="text-[1.3rem] font-black text-cyan-50 drop-shadow-[0_0_12px_rgba(34,211,238,0.95)] mb-3">
                  {savingsMonthly.toFixed(2).replace(".", ",")} {isPrepaid ? '€ pro 4 Wochen' : '€ pro Monat'}
                </div>
                <div className="grid grid-cols-2 gap-2 text-[0.65rem]">
                  <div className="bg-cyan-950/40 rounded-lg px-2.5 py-1.5 border border-cyan-400/30">
                    <div className="text-cyan-300/80 mb-0.5">Pro Tag</div>
                    <div className="text-cyan-50 font-bold">{savingsDaily.toFixed(2).replace(".", ",")} €</div>
                  </div>
                  <div className="bg-cyan-950/40 rounded-lg px-2.5 py-1.5 border border-cyan-400/30">
                    <div className="text-cyan-300/80 mb-0.5">Pro Jahr</div>
                    <div className="text-cyan-50 font-bold">{savingsYear.toFixed(2).replace(".", ",")} €</div>
                  </div>
                  <div className="col-span-2 bg-cyan-950/50 rounded-lg px-2.5 py-1.5 border border-cyan-400/40">
                    <div className="text-cyan-300/80 mb-0.5">{isPrepaid ? 'Ersparnis pro 4 Wochen' : 'Über 24 Monate gespart'}</div>
                    <div className="text-cyan-50 font-bold text-[0.75rem]">{savingsTwoYears.toFixed(2).replace(".", ",")} €</div>
                  </div>
                </div>
                <div className="mt-2 text-[0.6rem] text-cyan-200/80 text-center">
                  gegenüber Standardpreis von {originalPrice.toFixed(2).replace(".", ",")} {priceLabel}
                </div>
              </div>
            </div>
          )}

          <div className="relative rounded-xl p-4 border-2 border-cyan-400/70 bg-gradient-to-br from-cyan-500/25 via-blue-600/20 to-slate-900/80 overflow-hidden mt-3 shadow-[0_0_20px_rgba(34,211,238,0.4)]">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(34,211,238,0.35),transparent_70%)] pointer-events-none"></div>
            <div className="relative flex items-center justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1.5">
                  <svg className="w-5 h-5 text-cyan-300 drop-shadow-[0_0_8px_rgba(34,211,238,0.8)]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="3" y="7" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 7V4h5v3" />
                    <path d="M7 12h10" />
                    <circle cx="12" cy="15" r="2" />
                  </svg>
                  <div className="text-[0.7rem] uppercase tracking-wider text-cyan-200 font-bold">
                    {isJahrespaket ? 'Jahreskosten (einmalig)' : isConsumptionBased ? 'Grundgebühr' : isPrepaid ? 'Kosten pro 4 Wochen' : 'Gesamtkosten über 24 Monate'}
                  </div>
                </div>
                <div className="text-[1.4rem] font-black text-cyan-50 drop-shadow-[0_0_12px_rgba(34,211,238,0.9)] tracking-tight">
                  {isConsumptionBased ? 'Verbrauchsbasiert' : `${totalCost.toFixed(2).replace(".", ",")} €`}
                </div>
                <div className="text-[0.6rem] text-cyan-200/80 mt-0.5">
                  {isJahrespaket ? 'Einmalzahlung für 365 Tage' : isPrepaid ? 'keine Vertragsbindung' : `inkl. ${connectionFee > 0 ? 'Anschlusspreis' : 'ohne Anschlusspreis'}`}
                </div>
              </div>
              <div className="flex flex-col items-end gap-1">
                <div className="px-3 py-1 rounded-full bg-cyan-400/30 border border-cyan-300/60">
                  <span className="text-[0.65rem] font-bold text-cyan-50">{isJahrespaket ? '365 Tage' : isPrepaid ? '4 Wochen' : '24 Monate'}</span>
                </div>
                <div className="text-[0.6rem] text-cyan-300/90">
                  {isJahrespaket ? `täglich ${perDay.toFixed(2).replace(".", ",")} €` : isPrepaid ? '4-Wochen-Preis' : `monatlich ${effectivePrice.toFixed(2).replace(".", ",")} €`}
                </div>
              </div>
            </div>
          </div>

          <div className="pt-1">
            <button
              aria-label={`Tarif bearbeiten: ${title}`}
              className="w-full px-3 py-1.5 rounded-lg border border-sky-500/70 bg-sky-500/10 text-[0.72rem] font-semibold text-sky-100 hover:bg-sky-500/20 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                if (onEditRequest && id != null) onEditRequest(id);
              }}
            >
              Tarif bearbeiten
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
